import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * The tabs of an action, styled like the tab bar of the customer portal: a muted strip, the
 * active tab a white field on it. No rounded corners (house design canon).
 */
export function navLinkClassName({ isActive }: { isActive: boolean }): string {
  return [
    'inline-flex items-center rounded-md px-4 py-2 text-sm font-medium',
    isActive
      ? 'bg-background text-foreground shadow-sm'
      : 'text-muted-foreground hover:text-foreground',
  ].join(' ');
}
